// extracted by mini-css-extract-plugin
module.exports =  {"skeleton-item":"_93444fe79c--skeleton-item--c0qLS"};